import { Link, useLocation } from "react-router-dom";
import { AUDIENCE, getAudience } from "../audience";
import { seekerSteps } from "../content/seeker";
import { employerSteps } from "../content/employer";
import { useMarketingAuthUi } from "../MarketingAuthUi";

export default function HowItWorks() {
  useLocation(); // re-read audience after navigations that set cmAudience
  const { openRegister } = useMarketingAuthUi();
  const audience = getAudience();
  const steps =
    audience === AUDIENCE.EMPLOYER ? employerSteps : seekerSteps;
  const title =
    audience === AUDIENCE.EMPLOYER
      ? "How CareerMaster works for employers"
      : audience === AUDIENCE.SEEKER
        ? "How CareerMaster works for job seekers"
        : "How CareerMaster works";

  return (
    <article className="mkt-page">
      <header className="mkt-hero">
        <h1>{title}</h1>
        {!audience && (
          <p>
            Choose whether you are a{" "}
            <Link to="/">job seeker or employer</Link> for the path that fits
            you — or browse the steps below for seekers.
          </p>
        )}
      </header>

      <ol className="mkt-steps">
        {steps.map((s) => (
          <li key={s.step}>
            <span className="mkt-steps__num">{s.step}</span>
            <div>
              <h2>{s.title}</h2>
              <p>{s.body}</p>
            </div>
          </li>
        ))}
      </ol>

      <div className="mkt-cta-row">
        <button
          type="button"
          className="mkt-btn mkt-btn--primary"
          onClick={openRegister}
        >
          Create account
        </button>
        {!audience && (
          <Link className="mkt-btn mkt-btn--ghost" to="/">
            Choose your path
          </Link>
        )}
      </div>
    </article>
  );
}
